import {
  isCompletedFact,
  getBottomComponentHtml,
} from './table-view';

import {
  decoderElement,
  decoders,
} from './decode-fact';

require('./fact-bottom.component.scss');

export function FactBottomComponent($compile) {
  return {
    restrict: 'AE',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '=',
    },
    controller: function(
      $scope,
      $timeout,
      $element,
      $q,
      $sce,
      LocalStorageService,
      FaceService,
      AggregateDataService,
      RouterService,
      FilterResource,
      CurrentFilterDataService,
    ) {
      $scope.loadingId = 0;
      $scope.$timeout = $timeout;
      $scope.FilterResource = FilterResource;
      $scope.RouterService = RouterService;
      $scope.AggregateDataService = AggregateDataService;
      $scope.CurrentFilterDataService = CurrentFilterDataService;
      $scope.$q = $q;
      $timeout(() => $scope.AggregateDataService = AggregateDataService, 200);

      $scope.trustAsHtml = $sce.trustAsHtml;
      const setHeight = function() {
        $element.height('100%');
      };

      $scope.$on('dashboardResize', setHeight);
      $scope.$on('resize', setHeight);
      $scope.$on('splitter3Changed', (e, d, d2, name) => {
        setHeight();
      });

      const getTextElement = e => {
        const widgetElement = e.target.closest('.widget-filter') || e.target.closest('.widget-value');
        const textElement = widgetElement.querySelector('.fact-text');
        return textElement ? textElement : widgetElement;
      };

      $scope.decodeText = (e, type) => {
        const textElement = getTextElement(e);
        if (!textElement.innerTextOriginal) textElement.innerTextOriginal = textElement.innerText;
        const decoded = decoders[type](textElement.innerTextOriginal);
        textElement.innerText = decoded;
      };

      $scope.copyToClippboard = (e, text) => {
        e.stopPropagation();
        if (!text) {
          text = getTextElement(e).innerText;
        }
        LocalStorageService.copyTextToClipboard(text);
      };

      $scope.openFace = (fact, index) => {
        FaceService.openFace(fact, index);
      };

      $scope.connectRemoteUser = e => {
        if (!$scope.isRemote()) return;
        if ($scope.fact['agent_account.guid'])
          $scope.RouterService.openFrame('/remote/?hwid=' + $scope.fact['agent_agent.guid'] + '/' + $scope.fact['agent_account.guid']);
        else
          $scope.RouterService.openFrame('/remote/?hwid=' + $scope.fact['agent_agent.guid']);
      };

      $scope.isRemote = () => {
        if ($scope.AggregateDataService && $scope.AggregateDataService.allRemoteUsers &&
          $scope.AggregateDataService.allRemoteUsers.length) {
          return $scope.AggregateDataService.allRemoteUsers.some(rUser => {
            return rUser.hwid == $scope.fact['agent_agent.guid'];
          });
        }
        return false;
      };
    },
    link: function(scope, element, attrs) {
      const setIFrameHeight = element => {
        const _setIFrameHeight = () => {
          const iIrame = element.find('iframe.text_iframe');
          if (!iIrame.length) return null;
          const iDoc = iIrame.contents();
          scope.iFrameHeight = iDoc.find('html').height();
          if (scope.iFrameHeight) iIrame.height(scope.iFrameHeight + 15);
        };
        if (scope.timeoutId) clearTimeout(scope.timeoutId);

        scope.timeoutId = scope.$timeout(() => {
          _setIFrameHeight();
          if (!scope.iFrameHeight) {
            scope.timeoutId = scope.$timeout(() => {
              _setIFrameHeight();
            }, 300);
          }
        }, 200);
      };

      scope.isHighlights = () => highlights.length;

      let highlights = [];
      let currentHighlight = -1;
      let prevHighlight = -1;

      const setHighlights = () => {
        currentHighlight = -1;
        prevHighlight = -1;
        highlights = [];
        const bt_element = document.querySelector('.fact-table-details pre');
        for (let i = 0; i <= 9; i++) {
          const elems = bt_element.querySelectorAll(`sc-text-fact .text z${i}`);
          elems.forEach((el, i) => {
            if (el &&  !el.querySelector(el.tagName)) {
              const rect = el.getBoundingClientRect();
              const top = rect.top;
              const left = rect.left;
              highlights.push({
                el,
                top,
                left,
              });
            }
          });
        }
        highlights.sort((a, b) => a.top === b.top ? a.left - b.left : a.top - b.top);
      };

      scope.toHighlight = back => {
        currentHighlight = back ?
          (currentHighlight < 1 ? highlights.length - 1 : currentHighlight - 1) :
          (currentHighlight + 1 >= highlights.length ? 0 : currentHighlight + 1);
        const elem = highlights[currentHighlight].el;
        elem.style.fontWeight = '900';
        elem.scrollIntoView();
        if (prevHighlight > -1 && prevHighlight !== currentHighlight)
          highlights[prevHighlight].el.style.fontWeight = '';
        prevHighlight = currentHighlight;
      };

      scope.$on('text-compiled', event => setHighlights());

      const btnToHighlight = '<span ng-if="isHighlights()" class="to-highlight"><button title="' + gettext('Переход к предыдущему слову') +
        '" ng-if="isHighlights()" ng-click="toHighlight(true)"><i class="icon-chevron-left"/>' +
        gettext('К предыдущему слову') + '</button> <button "' + gettext('Переход к предыдущему слову') +
        '" ng-click="toHighlight(false)">' +
        gettext('К следующему слову') + '<i class="icon-chevron-right"/></button></span>';


      scope.$watch('fact', function(newVal, oldVal) {
        if (!scope.filter) return;
        let widget2 = '';
        const fact = newVal ? newVal : {};
        scope.loadingId = fact.id;
        if (!isCompletedFact(fact)) {

          widget2 = '<sc-spinner style="z-index: 999; "></sc-spinner>';
          if (scope.CurrentFilterDataService.loadingFact && scope.CurrentFilterDataService.loadingFact.loading) {
            scope.CurrentFilterDataService.loadingFact.canceller.resolve();
          } else {
            scope.CurrentFilterDataService.loadingFact = {
              loading: true,
            };
          }
          const canceller = scope.$q.defer();
          scope.CurrentFilterDataService.loadingFact.canceller = canceller;
          scope.CurrentFilterDataService.loadingFact.promise =
            scope.FilterResource.getCompleteFact(scope.filter, fact.id, canceller)
            .then(data => {
              scope.CurrentFilterDataService.loadingFact.loading = false;
              if (data && fact.id == data.id) {
                Object.assign(fact, data);

                if (scope.loadingId == data.id) {
                  widget2 = getBottomComponentHtml(fact);
                  widget2 += btnToHighlight;
                  element.html(widget2);
                  $compile(element.contents())(scope);
                  setIFrameHeight(element);
                }
              }
            }, e => {
              // if e.status == -1  request canselled;
              if (e.status !== -1)
                console.error(e);
            });
        }
        widget2 += getBottomComponentHtml(fact);
        widget2 += btnToHighlight;
        element.html(widget2);
        $compile(element.contents())(scope);
        setIFrameHeight(element);
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-bottom.component.js